/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum ProcedureStatusReason {
  SCT_183932001 = 'Procedure Contraindicated',

  SCT_416406003 = 'Procedure Discontinued',

  SCT_416237000 = 'Procedure Not Done',

  SCT_428119001 = 'Procedure Not Indicated',

  SCT_416064006 = 'Procedure Not Offered',

  SCT_416432009 = 'Procedure Not Wanted',

  SCT_183944003 = 'Procedure Refused',

  SCT_394908001 = 'Procedure Stopped',
}
